<template>
  <div class="service-options-with-swoop spaced-info-section" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="container">
      <div class="row title-row">
        <div class="col-xs-12 text-center">
          <h1>Your One Stop Shop at Auto Dealer</h1>
          <h4>In addition to the best deals on <a href="#">new</a> and <a href="#">pre-owned</a> vehicles, Auto Dealer has all of your needs covered. From service and repairs to financing and trade, we're here to help you get the most out of your Auto Dealer experience.</h4>
        </div>
      </div>
      <div class="row finance-row">
        <div class="col-sm-6 animation-element slide-left">
          <h1>Apply for Financing</h1>
          <h3>Our online finance application is fast, easy, and secure.</h3>
          <p>
            Your dealership is dedicated to delivering comprehensive and
            affordable financing options to drivers in City, State. Our
            financing team is filled with knowledgeable professionals
            experienced in processing auto loans and leases. Each time one of our loyal customers is ready to begin their financing journey at your dealership, they can count on finding a loan or lease option that works with their lifestyle and needs. Looking to put the car of your dreams in your driveway, on your terms? Fill out your finance application at your dealership today!
          </p>
          <a href="#" class="btn info-btn">Apply Now</a>
        </div>
        <div class="col-sm-6 animation-element slide-right">
          <img
            class="img-responsive center-block"
            src="../../static/images/buy-a-car.jpeg"
          />
        </div>
      </div>
      <div class="row trade-row">
        <div class="col-sm-6 animation-element slide-left">
          <img class="img-responsive center-block" src="../../static/images/trade-side-img-keyandmoney.jpeg">
        </div>
        <div class="col-sm-6 animation-element slide-right">
          <h1>Value Your Trade</h1>
          <h3>At your dealership in City, State</h3>
          <p>At Auto Dealer, we base our estimates on factors such as year, make, model, and trim of your vehicle when determining a trade-in value. Making the decision to trade-in or sell your car, truck, minivan, SUV or crossover is simple when you’re given the most accurate numbers available from Auto Dealer. Fill out our form online and make the confident choice to drive off our lot in a brand-new vehicle from Auto Dealer in City, State!</p>
          <a class="btn info-btn" href="#">Value Your Trade</a>
        </div>
      </div>
      <div class="row repair-row">
        <div class="col-xs-12">
          <h1 class="text-center">Service and Repair at Auto Dealer</h1>
        </div>
        <div class="col-sm-4 animation-element slide-left">
          <img class="img-responsive center-block" :src="images.swoopIcons[0]">
          <h3>Service</h3>
          <p>The service staff and technicians at Auto Dealer are highly trained on all factory services for your car. Stop by and find out what our customers, their family and friends have discovered and come to depend on: for maintenance, repairs, warranty concerns on all <span>{{brandName}}</span> vehicles. Auto Dealer defines service excellence.</p>
          <a class="btn info-btn" href="#">Schedule Service</a>
        </div>
        <div class="col-sm-4 animation-element bounce-up">
          <img class="img-responsive center-block" :src="images.swoopIcons[1]">
          <h3>Parts</h3>
          <p>Auto Dealer boasts an on-site parts department that will help you secure all the genuine <span>{{brandName}}</span> parts you need to complete a job on your vehicle today! Our team members are knowledgeable on all things <span>{{brandName}}</span> and are eager to hear about the upcoming repair you plan on completing. From vehicle belts and hoses to accessories that give your vehicle a personal touch, we have your parts needs covered!</p>
          <a class="btn info-btn" href="#">Order Parts</a>
        </div>
        <div class="col-sm-4 animation-element slide-right">
          <img class="img-responsive center-block" :src="images.swoopIcons[2]">
          <h3>Collision</h3>
          <p>Auto Dealer's collision center can help with all of your collision repair or auto body repair needs. From the initial estimate all the way to getting you back in the driver's seat, our certified collision center will get your vehicle repaired properly. We work closely with your insurance company to provide you with fast and accurate accident repair. We also can perform maintenance and customization of your vehicle to repair or maintain or even upgrade its appearance.</p>
          <a class="btn info-btn" href="#">Learn More</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
    (function() {
      var scrollSwoop = {
        init: function() {
          var $animation_elements = $(".animation-element");
          var $window = $(window);

          function check_if_in_view() {
            var window_height = $window.height() * 0.8;
            var window_top_position = $window.scrollTop();
            var window_bottom_position = window_top_position + window_height;

            $.each($animation_elements, function() {
              var $element = $(this);
              var element_height = $element.outerHeight();
              var element_top_position = $element.offset().top;
              var element_bottom_position =
                element_top_position + element_height;

              if (
                element_bottom_position >= window_top_position &&
                element_top_position <= window_bottom_position
              ) {
                $element.addClass("in-view");
              }
            });
          }

          $window.on("scroll resize", check_if_in_view);
          $window.trigger("scroll");
        },
      };
      $(document).ready(scrollSwoop.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.spaced-info-section {
  font-size: 16px;
  background: #fff;
  padding: 3% 0;
}
.spaced-info-section h1 {
  font-weight: 300;
}
.spaced-info-section h4 {
  line-height: 1.5;
}
.spaced-info-section h4 a {
  font-size: inherit !important;
}
.spaced-info-section .row {
  padding: 3% 0;
}
.spaced-info-section a {
  color: var(--primary-color);
}
.spaced-info-section[data-brand="cjdr"] a {
  color: var(--secondary-color);
}
.spaced-info-section .info-btn {
  color: #FFF !important;
  background: var(--primary-color);
  font-size: 20px;
  padding: 8px 26px;
  margin: 15px auto;
  border-radius: 4px;
  box-shadow: 2px 13px 27px -10px #0f032c;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-property: transform;
  transition-property: transform;
}
.spaced-info-section[data-brand="cjdr"] .info-btn {
  background: var(--secondary-color);
}
.spaced-info-section .info-btn:hover {
  transform: scale(0.97);
  box-shadow: 0px 5px 25px -4px #0f032c;
  text-decoration: none;
}
.spaced-info-section .repair-row {
  text-align: center;
}
.spaced-info-section .repair-row h1 {
  margin-bottom: 30px;
}
.spaced-info-section .repair-row img {
  max-height: 92px;
}

@media (min-width: 768px) {
  .animation-element.slide-left {
    opacity: 0;
    -moz-transition: all 500ms linear;
    -webkit-transition: all 500ms linear;
    -o-transition: all 500ms linear;
    transition: all 500ms linear;
    -moz-transform: translate3d(-100px, 0px, 0px);
    -webkit-transform: translate3d(-100px, 0px, 0px);
    -o-transform: translate(-100px, 0px);
    -ms-transform: translate(-100px, 0px);
    transform: translate3d(-100px, 0px, 0px);
  }

  .animation-element.slide-left.in-view {
    opacity: 1;
    -moz-transform: translate3d(0px, 0px, 0px);
    -webkit-transform: translate3d(0px, 0px, 0px);
    -o-transform: translate(0px, 0px);
    -ms-transform: translate(0px, 0px);
    transform: translate3d(0px, 0px, 0px);
  }

  .animation-element.slide-right {
    opacity: 0;
    -moz-transition: all 500ms linear;
    -webkit-transition: all 500ms linear;
    -o-transition: all 500ms linear;
    transition: all 500ms linear;
    -moz-transform: translate3d(100px, 0px, 0px);
    -webkit-transform: translate3d(100px, 0px, 0px);
    -o-transform: translate(100px, 0px);
    -ms-transform: translate(100px, 0px);
    transform: translate3d(100px, 0px, 0px);
  }

  .animation-element.slide-right.in-view {
    opacity: 1;
    -moz-transform: translate3d(0px, 0px, 0px);
    -webkit-transform: translate3d(0px, 0px, 0px);
    -o-transform: translate(0px, 0px);
    -ms-transform: translate(0px, 0px);
    transform: translate3d(0px, 0px, 0px);
  }

  .animation-element.bounce-up {
    opacity: 0;
    -moz-transition: all 500ms ease-out;
    -webkit-transition: all 500ms ease-out;
    -o-transition: all 500ms ease-out;
    transition: all 500ms ease-out;
    -moz-transform: translate3d(0px, 40px, 0px);
    -webkit-transform: translate3d(0px, 40px, 0px);
    -o-transform: translate(0px, 40px);
    -ms-transform: translate(0px, 40px);
    transform: translate3d(0px, 40px, 0px);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .animation-element.bounce-up.in-view {
    opacity: 1;
    -moz-transform: translate3d(0px, 0px, 0px);
    -webkit-transform: translate3d(0px, 0px, 0px);
    -o-transform: translate(0px, 0px);
    -ms-transform: translate(0px, 0px);
    transform: translate3d(0px, 0px, 0px);
  }

  .spaced-info-section .title-row {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media (max-width: 767px) {
  .service-options-with-swoop {
    text-align: center;
  }
}
</style>
